import script from "./ShareBrowseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareBrowseHeader.vue?vue&type=script&setup=true&lang=js"

import "./ShareBrowseHeader.vue?vue&type=style&index=0&id=515e1cd6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-515e1cd6"]])

export default __exports__